import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://jokkkjuvydarwembwfuj.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impva2tranV2eWRhcndlbWJ3ZnVqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyODAxOTAsImV4cCI6MjA1OTg1NjE5MH0.P4TJeNEmGR8CXUYK6RHrvhN1NjwbUgzRE15sLxgXU6I';
// const supabaseUrl = 'https://bzxpvubyowenvvqgopfn.supabase.co';
// const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ6eHB2dWJ5b3dlbnZ2cWdvcGZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY3NTQ4MzYsImV4cCI6MjA4MjMzMDgzNn0.VCGmi0G-SIn0pzmPSpgntxpM-iOPlqRKkmWIYpC1G9M';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        storageKey: 'sb-auth-token',
        storage: localStorage,
        autoRefreshToken: true,
        detectSessionInUrl: true
    }
});

